<div class="account-shell__content">
  <div class="row">
    <div class="pg-wrapper">
      <!-- Телефон не подтверждён  -->
      <div class="account-shell__content-wrapper" *ngIf="phoneVerified === false">
        <div class="profile__confirmed status-warning">
          <div class="grid align-items-center justify-content-center flex-column">
            <div class="col-12 col-sm-12 text-center">
              <span class="mr-icon mr-icon-status-error mt-2 mb-4"></span>
              <h5>Ваш телефон не подтвержден!</h5>
              <p class="mt-2 mb-6">
                Раздел доступен только пользователям с подтвержденным номером телефона.
              </p>
            </div>
            <div class="col-12 col-sm-12 text-center">
              <a
                [routerLink]="['/', Routing.Account, Routing.AccountUser]"
                class="txt-link"
              >
                Перейти в профиль
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Основной контент — только при подтверждённом телефоне -->
      <div class="account-shell__content-wrapper" *ngIf="phoneVerified === true">
        <div class="performers">
          <div class="performers__actions">
            <div class="performers__create-row">
              <div class="performers__create-heading">
                <label for="new-performer-name" class="performers__create-label">Создайте страницу исполнителя:</label>
                <p class="performers__create-disclaimer txt-caption">Чтобы заказчики могли найти вас и пригласить на выступление</p>
              </div>
              <div class="ui-input ui-input__text performers__create-input-wrap">
                <input
                  id="new-performer-name"
                  type="text"
                  [(ngModel)]="newPerformerName"
                  placeholder="Руки вверх"
                  maxlength="200"
                  [readonly]="isMaxPerformersReached"
                  (keydown.enter)="goToCreatePerformer($event)"
                />
              </div>
              <button
                type="button"
                class="ui-buttons ui-buttons__blue-large performers__create-btn"
                [class.performers__create-btn--disabled]="isMaxPerformersReached"
                (click)="goToCreatePerformer($event)"
                [attr.aria-label]="'Перейти к созданию страницы'"
                [disabled]="isMaxPerformersReached"
              >
                <i class="pi pi-arrow-right"></i>
              </button>
            </div>
            <p class="performers__max-reached txt-caption" *ngIf="isMaxPerformersReached">
              Создано максимально доступное количество страниц исполнителя
            </p>
          </div>

          <p class="performers__error txt-caption" *ngIf="errorMessage">{{ errorMessage }}</p>
          <p class="performers__loading txt-caption" *ngIf="loading && !performersList.length">Загрузка...</p>

          <div class="performers__grid grid" *ngIf="!loading || performersList.length">
            <div class="performers__card col-12 col-md-4 col-lg-4 col-hq-4" *ngFor="let item of performersList; trackBy: trackByPerformerId">
              <div class="performers-card">
                <div class="performers-card__preview">
                  <img
                    *ngIf="item.thumbnailPath"
                    [src]="StaticURL + item.thumbnailPath"
                    [alt]="item.name"
                    class="performers-card__img"
                    onerror="this.classList.add('performers-card__img--error')"
                  />
                  <div *ngIf="!item.thumbnailPath" class="performers-card__placeholder">
                    <img src="assets/images/others/balalaika_light.svg" alt="" class="performers-card__placeholder-icon" />
                    <span class="txt-caption">Нет фото</span>
                  </div>
                </div>
                <div class="performers-card__body">
                  <div class="performers-card__row">
                    <span class="performers-card__label">Имя / Псевдоним</span>
                    <p class="performers-card__value performers-card__value--name">{{ item.name }}</p>
                  </div>
                  <div class="performers-card__row">
                    <span class="performers-card__label">Город</span>
                    <p class="performers-card__value">{{ getCityName(item) }}</p>
                  </div>
                  <div class="performers-card__row">
                    <span class="performers-card__label">Ссылка на страницу</span>
                    <p class="performers-card__value performers-card__link-row">
                      <ng-container *ngIf="item.slug">
                        <a [href]="getPublicUrl(item)" target="_blank" rel="noopener" class="txt-link performers-card__link" [attr.title]="'Открыть публичную страницу'">
                          {{ getPublicUrl(item) }}
                        </a>
                        <button type="button" class="performers-card__copy-btn" (click)="onCopyLink(item); $event.preventDefault()" [attr.title]="'Скопировать ссылку'" [attr.aria-label]="'Скопировать ссылку'">
                          <i class="pi pi-copy"></i>
                        </button>
                        <span class="performers-card__copy-msg" *ngIf="copiedLinkId === item.id">Ссылка скопирована</span>
                      </ng-container>
                      <span *ngIf="!item.slug">—</span>
                    </p>
                  </div>
                  <div class="performers-card__row">
                    <span class="performers-card__label">Дата создания</span>
                    <p class="performers-card__value">{{ formatDate(item.createdAt) }}</p>
                  </div>
                  <div class="performers-card__actions">
                    <p
                      class="txt-link performers-card__edit-link"
                      (click)="onEdit(item)"
                      role="button"
                      tabindex="0"
                      (keydown.enter)="onEdit(item)"
                    >
                      Редактировать
                    </p>
                    <div class="performers-card__toggle">
                      <p-inputSwitch [ngModel]="item.isPublished" (onChange)="onTogglePublish(item)" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                      <span class="performers-card__toggle-label">{{ item.isPublished ? 'Опубликован' : 'Скрыт' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="performers__empty txt-caption" *ngIf="!loading && !errorMessage && performersList.length === 0">
            <p>У вас пока нет страниц исполнителей.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
